import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextContentIt = () => {
    return (
        <HighlightedText
            text="RICHIEDI IL TUO BONUS bonus del 325% + 400 GIRI GRATUITI"
            highlights={[{ word: '325%' }, { word: '400' }]}
            breakAfterWords={['TUO', '325%']}
            breakBeforeWords={['bonus del']}
            className={styles.text_content}
        />
    )
}
